import * as React from 'react';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import 'src/modules/my-account/physical-person-update/forms/Dropzone.css';
import FileImage from 'src/modules/commons/images/FileImage.component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

interface Props {
  investorDeckDocument?: File;
  investorDeckDocumentName?: string;
  disableButton: boolean;
  errorMessages: {};
  handleClick: (value: string) => void;
  createInvestorDeck: () => void;
  handleChange: (key: string) => (value: boolean | File) => void;
}

const InvestorDeckStep2Component: React.StatelessComponent<Props> = (props: Props) => (
  <div className="tab-content padding-40">
    <h4><strong>Envía tu "Investor deck"</strong></h4>
    <p className="invest-subtitle">
      Cómo has contestado que sí a todas las preguntas, podemos empezar con el proceso de envío de tu operación.
    </p>

    <div className="row">
      <div className="col-sm-6 col-md-4">
        <ReactDropzone
          className="dropzone text-center pointer"
          onDrop={(files: ImageFile[]) => {
            if (files[0]) {
              props.handleChange('investorDeckDocument')(files[0]);
            }
          }}
          multiple={false}
          accept="application/pdf"
        >
          <FileImage
            alt="Investor Deck"
            defaultImagePath={props.investorDeckDocument ? '/img/corrected.png' : '/img/graphic-big-color.png'}
          />
          <div className="gap-10" />
          <p className="text-center">
            {props.investorDeckDocumentName ? props.investorDeckDocumentName : 'Subir el "Investor Deck"'}

          </p>
        </ReactDropzone>
        <div className="gap-20" />
      </div>
    </div>

    <p><strong>Requisitos:</strong></p>
    <p>
      El documento tienes que ser *.pdf<br />
      El documento no puede estar protegido para apertura.<br />
      El tamaño máximo del documento debe de ser inferior a 20 MB.
    </p>

    <div className="gap-50" />
    <ErrorMessagesComponent errorMessage={props.errorMessages}/>
    <p className="text-center">
      <button
        className="btn btn-secondary send-button"
        onClick={() => props.createInvestorDeck()}
        disabled={props.disableButton}
      >
        Enviar
      </button>
    </p>
  </div>
);

export default InvestorDeckStep2Component;



// WEBPACK FOOTER //
// ./src/modules/investor-deck/partials/InvestorDeckStep2.component.tsx